import { render, staticRenderFns } from "./DatePickerOrder.vue?vue&type=template&id=5838a817&scoped=true&lang=pug&"
import script from "./DatePickerOrder.vue?vue&type=script&lang=js&"
export * from "./DatePickerOrder.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerOrder.vue?vue&type=style&index=0&id=5838a817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838a817",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDatePicker,VSpacer})
